import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { EDU_HD_CONFIG } from "./edu-detail-content";
import { ProductDetailHdPage } from "./ProductDetailHdPage";

export interface EduProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** Edu HD page — thin wrapper over the shared ProductDetailHdPage. */
export function EduProductDetailHd(props: EduProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={EDU_HD_CONFIG} />;
}
